import React, {FormEvent} from 'react';
import styles from './hsaAuthPageLayout.module.scss';
// import logo from './logo.png';
import { NavLink } from 'react-router-dom';
// import { VideoPlayer } from '@components';
// import { AuthPageVideoLink } from '@constants'

type Common = {
  children: React.ReactNode | any;
  title: string;
  backToLogin?: boolean;
  isParentAuth?: boolean;
  isRegistration?: boolean;
  onSubmit?: (e: FormEvent) => void;
}

type WithRender = {
  children: () => React.ReactNode;
}

type Props = Common | WithRender;

function AuthPageLayout(props: Props) {
  const { children } = props;
  const { title, backToLogin, onSubmit } = props as Common;

  return (
    <div className={styles.page}>
      {/* <div className={styles.left}>
      <VideoPlayer src={AuthPageVideoLink} className={styles.video} autoPlay={false} metaData={{video_title: 'Parent Description'}}/>
        <img className={styles.top_logo} src={logo} alt="Logo" />                         
        <div className={styles.bottom_textBody}>
          <h5 className={styles.description}>
            {
              '{Proper intro for parents} Parents are not trained to be mental health experts. With pre-prepared Online Lessons created by Clinical Psychologists, your teachers can now support the mental health of all your students.'
            }
          </h5>
        </div>
      </div> */}
      <div className={styles.right}>
        <div className={styles.rightContent}>
          <div className={styles.loginTitle}>{title}</div>
          {typeof children === 'function' ? children() :
            <form onSubmit={onSubmit}>
              {children}
              {backToLogin &&
                <div className={styles.back}>
                  Back&nbsp;to&nbsp;<NavLink className={styles.backLink} to={'/login'}>Login</NavLink>
                </div>
              }
            </form>
          }
        </div>
        <div className={styles.footer}>
          © {(new Date().getFullYear()) || '2022'} Open Parachute Ltd. All rights reserved.
        </div>
      </div>
    </div>
  );
}

export default AuthPageLayout;
